import React, { useEffect } from "react";
import TabPanel from "./userTabs";
import { Button, Dialog } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import EmployeeTable from "./EmployeeTable";
import { UserService } from "../../../services/user.service";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import EmployeeForm from "../../shared/user/EmployeeForm";
import { AuthService } from "../../../services/auth.service";

const Employee = ({ value, index, addAlert, detailAlert }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [resetCheckBox, setResetCheckbox] = React.useState(false);
  const [userArray, setUserArray] = React.useState([]);

  useEffect(() => {
    getAllUsers();
  }, []);

  const getAllUsers = async () => {
    try {
      const { id } = AuthService.currentUserValue;
      const { data } = await UserService.getUsersActive();
      const filterUsers = data.filter((user) => user.id !== id);
      setUserArray(filterUsers);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({ severity: "error", message: error.msgs });
    }
  };

  const removeUser = (isUserRemove) => {
    addAlert({ showAlert: true });
    if (isUserRemove) {
      getAllUsers();
      detailAlert({
        severity: "success",
        message: "Usuario(s) eliminado exitosamente",
      });
      setResetCheckbox(true);
    } else {
      detailAlert({
        severity: "error",
        message: "Error al eliminar el usuario(s)",
      });
    }
  };

  const handleSubmitedForm = (operation, user) => {
    if (operation === "create") console.log("user to created", user);
    UserService.createUser(user)
      .then((resp) => {
        console.log(resp);
        if (resp && resp.status === 201) {
          addAlert({ showAlert: true });
          detailAlert({
            severity: "success",
            message: "Usuario creado exitosamente",
          });
          getAllUsers();
        }
      })
      .catch((err) => {
        console.log(err);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: err.msgs });
      });
  };

  const handleReloadUsers = (usersType) => {
    // console.log("usersType ======= ", usersType);
    if (usersType === "employee") getAllUsers();
    setResetCheckbox(true);
  };

  const handleCloseDialog = () => setOpenDialog(false);

  return (
    <React.Fragment>
      <TabPanel value={value} index={index}>
        <Button
          color="primary"
          variant="contained"
          onClick={() => setOpenDialog(true)}
          style={{ margin: "3vh 1vh" }}
          endIcon={<AddIcon color="secondary"></AddIcon>}
        >
          Nuevo empleado
        </Button>
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="form-dialog-title"
        >
          <EmployeeForm
            userCreated={handleSubmitedForm}
            closeDialog={handleCloseDialog}
          />
        </Dialog>

        {userArray.length > 0 && (
          <EmployeeTable
            resetCheckox={resetCheckBox}
            userArray={userArray}
            loadUsers={handleReloadUsers}
            isUserDeleted={removeUser}
          ></EmployeeTable>
        )}
      </TabPanel>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(Employee);
